import { NgModule } from '@angular/core';
import { BadgeModule } from 'primeng/badge';
import { ConfirmPopupModule } from 'primeng/confirmpopup';
import { MultiSelectModule } from 'primeng/multiselect';
import { AppSharedModule } from 'src/app/app-shared.module';

import { PageWithHeaderModule } from 'presentation/common/component/page-with-header/page-with-header.module';
import { CoachSettingsGeneralBiographyComponent } from 'presentation/page/settings/coach-settings/coach-settings-general/coach-settings-general-biography/coach-settings-general-biography.component';
import { CoachSettingsGeneralCertificatesComponent } from 'presentation/page/settings/coach-settings/coach-settings-general/coach-settings-general-certificates/coach-settings-general-certificates.component';
import { CoachSettingsGeneralDiplomaComponent } from 'presentation/page/settings/coach-settings/coach-settings-general/coach-settings-general-diploma/coach-settings-general-diploma.component';
import { CoachSettingsGeneralInformationComponent } from 'presentation/page/settings/coach-settings/coach-settings-general/coach-settings-general-information/coach-settings-general-information.component';
import { CoachSettingsGeneralSectorsComponent } from 'presentation/page/settings/coach-settings/coach-settings-general/coach-settings-general-sectors/coach-settings-general-sectors.component';

import { CoachSettingsBiographyComponent } from './coach-settings/coach-settings-biography/coach-settings-biography.component';
import { CoachSettingsCalendarComponent } from './coach-settings/coach-settings-calendar/coach-settings-calendar.component';
import { CoachSettingsExternalConnectionComponent } from './coach-settings/coach-settings-general/coach-settings-external-connection/coach-settings-external-connection.component';
import { CoachSettingsGeneralCertificatesCertificateComponent } from './coach-settings/coach-settings-general/coach-settings-general-certificates/coach-settings-general-certificates-certificate/coach-settings-general-certificates-certificate.component';
import { CoachSettingsGeneralCertificatesHeaderComponent } from './coach-settings/coach-settings-general/coach-settings-general-certificates/coach-settings-general-certificates-header/coach-settings-general-certificates-header.component';
import { CoachSettingsGeneralDiplomaDiplomaComponent } from './coach-settings/coach-settings-general/coach-settings-general-diploma/coach-settings-general-diploma-diploma/coach-settings-general-diploma-diploma.component';
import { CoachSettingsGeneralDiplomaHeaderComponent } from './coach-settings/coach-settings-general/coach-settings-general-diploma/coach-settings-general-diploma-header/coach-settings-general-diploma-header.component';
import { CoachSettingsGeneralComponent } from './coach-settings/coach-settings-general/coach-settings-general.component';
import { CoachSettingsComponent } from './coach-settings/coach-settings.component';
import { CoacheeSettingsComponent } from './coachee-settings/coachee-settings.component';
import { SettingsInformationComponent } from './coachee-settings/settings-information/settings-information.component';
import { SettingsMfaComponent } from './coachee-settings/settings-mfa/settings-mfa.component';
import { SettingsNotificationsComponent } from './coachee-settings/settings-notifications/settings-notifications.component';
import { SettingsRoutingModule } from './settings-routing.module';

@NgModule({
	declarations: [
		CoachSettingsComponent,
		CoachSettingsBiographyComponent,
		CoacheeSettingsComponent,
		CoachSettingsCalendarComponent,
		CoachSettingsGeneralComponent,
		CoachSettingsGeneralInformationComponent,
		SettingsInformationComponent,
		SettingsNotificationsComponent,
		SettingsMfaComponent,
		CoachSettingsGeneralSectorsComponent,
		CoachSettingsGeneralBiographyComponent,
		CoachSettingsGeneralDiplomaComponent,
		CoachSettingsGeneralCertificatesComponent,
		CoachSettingsExternalConnectionComponent,
		CoachSettingsGeneralCertificatesCertificateComponent,
		CoachSettingsGeneralCertificatesHeaderComponent,
		CoachSettingsGeneralDiplomaHeaderComponent,
		CoachSettingsGeneralDiplomaDiplomaComponent,
	],
	imports: [
		AppSharedModule,
		SettingsRoutingModule,
		PageWithHeaderModule,
		BadgeModule,
		MultiSelectModule,
		ConfirmPopupModule,
	],
	exports: [],
	providers: [],
})
export class SettingsModule {}
